import React from 'react';
import { Container } from 'reactstrap';
import IdamanUserView from './Components/IdamanUserView';

const IdamanUser = () => {
  document.title = 'IDAMAN Users';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid className='px-0'>
          <IdamanUserView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IdamanUser;
